<template>
  <div class='classStu'>
    <div class='switchRole'>
      <van-tabs v-model="active" title-active-color='#0A59F7' color='#0A59F7' background='transparent' :ellipsis='false'>
              <van-tab :title="'学生('+list.length+')'" name='1' ></van-tab>
              <van-tab :title="'老师('+teacherList.length+')'" name='2' ></van-tab>
      </van-tabs>
    </div>
    <div class="main"  v-if="active==1">
      <p class="gray font14" style="padding:.18rem .12rem .12rem">左滑将学生移出班级</p>
      <van-swipe-cell v-for='(item,i) in list' :key='i'>
        <!-- <van-cell :border="false" title="单元格" value="内容" /> -->
        <div class='list flex-between'>
          <img v-if="item.gender==null" src='@/assets/img/mine/defaultheader.png' class='img'>
          <img v-if="item.gender==1" src='../../assets/img/peo1.png' class='img'>

          <img v-if="item.gender==2" src='../../assets/img/peo2.png' class='img'>

          <div class="name font15">
            <div class="font18">{{item.studentName}}</div>
            <div v-if="item.imei" class="gray"><span><img style="width: 0.16rem;vertical-align:text-bottom" src="../../assets/img/mine/greenlog.png" alt=""></span> 已绑定学生终端</div>
            <div v-else class="gray"><span ><img style="width: 0.16rem;vertical-align:text-bottom;" src="../../assets/img/mine/redlog.png"  alt=""></span> 未绑定学生终端</div>
          </div>
          <div class="tel" @click="getPhone(item)">联系家长</div>
          <!-- <div class="tel" @click="delStudent(item)" v-if="isMaster==1">移出班级</div> -->
          
        </div>
        <template #right v-if="isMaster==1">
          <!-- <div>移出班级</div> -->
          <van-button square type="danger" text="移出班级" @click="delStudent(item)"  class="delBtn font16"  />
        </template>
      </van-swipe-cell>
      <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/nodata.png")'><br />{{text}}</div></div>
    </div>
    <div v-if="active==2" class='list flex-between' v-for='(item,i) in teacherList' :key='i'>
       <img src='@/assets/img/teacher.png' class='img'>
       <div class="name font15">
          <div  class="font18">{{item.teacherName}}
            <span class="teacher_identity" v-if="item.isMaster==1" >  班主任</span>
            <span class="teacher_identity" style="background-color: #4BC12D;" v-if="item.teacherId==teacherId">我</span>
          </div>
          <div  class="gray"> {{item.phone}}</div>
        </div>
        <div style="width: 0.8rem;"><a :href='"tel:"+item.phone' class="tel" v-show="item.teacherId!=teacherId">呼叫</a></div>
     
    </div>
    <div class='noData' v-if="text&&teacherList.length==0"><div><img :src='require("@/assets/img/nodata.png")'><br />{{text}}</div></div>

    <div  v-if="active==1 && isMaster==1">
      <div class="my_btn">
          <div class="btn-primary " @click="getShare">邀请学生加入班级</div>
      </div>
      <template v-if="isShare">
        <div class="share" @click="isShare=false">
          <div class="bj"></div>
          <div class="shareTxt">
              <p class="txt">点击右上角进行分享</p>
          </div>
        </div>
      </template>
    </div>
    <van-action-sheet v-model="isShow" cancel-text="取消"
      close-on-click-action
      @cancel="onCancel">
       <div class='addCon'  v-if="active==1">
          <!-- <p class=' tit'>请选择拨打的电话</p> -->
          <div v-for='(item,i) in parentList' :key='i' class="con flex-center">
            <a :href='"tel:"+item.parentPhone' class='black font16'>{{item.parentName}}</a>
          </div>
       </div>
    </van-action-sheet>
    
    
  </div>
</template>
<script>
import {getStudentListByClassId,getParentInfoByStudentId,delStudentFromClass,madeInviteCode,getTeacherListByClassId,getStudentsList} from '@/api/api.mine.js';
import wxapi from '@/utils/wxapi.js';

import { Dialog } from 'vant';
  export default {
    data() {
      return {
        list:[],
        teacherList:[],
        classId:this.$route.query.classId,
        isMaster:this.$route.query.isMaster,
        className:this.$route.query.className,
        isShow:false,
        parentList:[],
        text:'',
        active:1,
        isShare:false,
        teacherIphone:"",
        teacherId:""
      }
    },
    created(){
      this.getList();
      this.getTeacherList()
      this.teacherId=this.loginUser.teacherId
    },  
    methods: {
      getList(){
        getStudentsList({
          classId:this.classId,
          schoolId:this.loginUser.schoolId
        }).then(data=>{
          if(data.result.length>0){
            this.list=data.result;
          }else{
            this.text='暂无数据';
          }
           
        })
      },
      getTeacherList(){
        getTeacherListByClassId({
          classId:this.classId,
        }).then(data=>{
          if(data.result.length>0){
            this.teacherList=data.result;
          }else{
            this.text='暂无数据';
          }
           
        })
      },
      getPhone(item){
        if(this.active==1){
          getParentInfoByStudentId({studentId:item.studentId}).then(data=>{
            if(data.result.parentList.length>0){
              this.parentList=data.result.parentList;
              this.isShow=true;
            }else{
              this.$toast('暂无家长信息')
              
            }
            
          })
        }
        
      },
      beforeClose(info,item){
        // console.log(info);
        // console.log(item);
      },
      delStudent(item){
        const _this=this
        Dialog.confirm({
          title: '移出班级',
          message: `确认要将${item.studentName}同学移出班级吗？`,
          confirmButtonText:'移出',
        })
          .then(() => {
            // on confirm
            delStudentFromClass({studentId:item.studentId,teacherId:this.loginUser.teacherId}).then((res)=>{
              console.log(res);
              _this.getList()
            })
          })
          .catch(() => {
            // on cancel
          });
        
      },
      onCancel(){
        this.isShow=false;
      },
      getShare(){
         madeInviteCode({teacherId:this.loginUser.teacherId,classId:this.classId}).then((res)=>{
          console.log(ENV_API.API_HOST+ `/app/#/classShare?inviteCode=${res.result}`);
          this.isShare=true;
          let option={
            myValue:'在鸿学生终端',
            title:`【${this.loginUser.teacherName}老师】邀请你家孩子加入班级【${this.className}】`,
            link:ENV_API.API_HOST+ `/app/#/classShare?identityCode=5&inviteCode=${res.result}`,
            imgs:ENV_API.API_HOST+'/app/static/shareLogo.png',
            success: () => {
            }
          }
          wxapi.shareAppMessage(option);
         })
         
       },
    },
  }
</script>
<style lang="scss" >
.classStu{
  font-size:.15rem;
  // padding:.1rem .15rem;
  .switchRole{
    background: #fff;
  }
  .delBtn{
     background:#FF5656;
     color:#fff;
     text-align: center;
     height:100%;
     .van-button__text{
        font-size: .16rem;
     }
  }
  .list{
      // line-height: .8rem;
      padding:.15rem .12rem;
      background: #fff;
      // margin-bottom: .1rem;
      border-bottom:1px solid #eee;
      color:rgba(0,0,0,.9);
      .img{
          width:.48rem;
          height: .48rem;
          vertical-align: middle;
      }
      .name{
        text-align: left;
        display: inline-block;
        width: 57%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .gray{
          margin-top: .05rem;
        }
      }
      .teacher_identity{
        overflow: hidden;
        padding:.02rem 0.03rem;
        margin-left: 10px;
        width: 0.41rem;
        height: 0.17rem;
        background: #FF6430;
        border-radius: 2px 2px 2px 2px;
        font-size: 0.11rem;
        text-align: center;
        font-weight: 400;
        color: #FFFFFF;
        opacity: 1;
        vertical-align:text-top;
      }
      .name_teacher{
        flex:0 0 80%;
        text-align: left;
        width: 50%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        
      }
      .tel{
        float: right;
        width: 0.8rem;
        height: 0.24rem;
        text-align: center;
        line-height: 0.24rem;
        border-radius: 18px;
        background-color: #F8F8F8;
        color:#0A59F7;
      }
  }
  .share{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 3;
    .bj{
      background: #000;
      opacity: .7;
      height: 100%;
      width: 100%;
    }
    .shareTxt{
      background:url(../../assets/img/mine/shareBack.png) no-repeat right top;
      position: absolute;
      top: 5px;
      right: 5px;
      padding: 110px 30px 0px 0px;
      color: #fff;
      background-size: 70px;
    }
  }
  .main{
    padding-bottom: 0.5rem !important;
  }
  .my_btn{
    position:fixed;
    bottom: 0.1rem;
    left: 0.15rem;
    width: 92%;
    overflow: hidden;
  }
  .con{
    line-height: .4rem;
    font-size: .14rem;
    &:last-child{
      border-bottom:none;
    }
  }
  .tit{
    text-align: center;
  }
 .cancel{
   text-align: center;
 }
 .black{
   color:#162746;
 }
}

</style>